import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchPettyCashChequeList = createAsyncThunk("fetchPettyCashChequeList", async ({ filters }) => {
	const formatDate = (date) => (date && date.isValid && date.isValid() ? date.format("YYYY-MM-DD") : "");

	const params = new URLSearchParams({
		page: filters?.page ?? 1,
		limit: filters?.limit ?? 10,
		keyword: filters?.keyword ?? "",
		department: filters?.department ?? "",
		float_id: filters?.float_id ?? "",
		start_at: filters?.dateRange && filters.dateRange[0] ? formatDate(filters.dateRange[0]) : "",
		end_at: filters?.dateRange && filters.dateRange[1] ? formatDate(filters.dateRange[1]) : "",
	});

	try {
		const response = await axiosHttp.get(`petty-cash/cheques?${params}`);
		return response.data;
	} catch (error) {
		throw error;
	}
});

const PettyCashChequeListSlice = createSlice({
	name: "PettyCashChequeListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		limit: 10,
		total: 0,
	},
	extraReducers: (builder) => {
		builder.addCase(fetchPettyCashChequeList.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		});
		builder.addCase(fetchPettyCashChequeList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload?.pagination?.page || action.payload?.page || 1;
			state.limit = action.payload?.pagination?.limit || action.payload?.limit || 10;
			state.total = action.payload?.pagination?.total || action.payload?.total || (action.payload?.data ? action.payload.data.length : 0);
		});
		builder.addCase(fetchPettyCashChequeList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload || action.error;
		});
	},
});

export default PettyCashChequeListSlice.reducer;
